import './i18n-types';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { registerLocalesHMR } from '@hero/lang';

const applyLanguageToDocument = (langCode: string) => {
  document.documentElement.lang = langCode;
  document.documentElement.dir = langCode === 'ar' ? 'rtl' : 'ltr';
};

const savedLang = localStorage.getItem('language') || 'en';
applyLanguageToDocument(savedLang);

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: savedLang,
    defaultNS: 'dashboard',
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['en', 'ar'],
    ns: [
      'registration',
      'dashboard',
      'applications',
      'toast',
      'dashboardMember',
      'dashboardHome',
      'validations',
      'loads',
      'a-carrier-dashboard',
      'c-main',
      'c-price',
      'c-dates',
      'm-analytics',
      'm-auth',
      'm-contact',
      'm-crm',
      'm-client',
      'm-location',
      'm-payment',
      'm-member',
      'm-order',
      'm-vehicle',
      'm-driver',
      'm-region',
      'm-route',
      'm-agreement',
      'm-pricing',
      'm-billing',
      'm-financing',
      'm-apps',
      'm-invoice',
      'm-account',
      'm-account-transaction',
      'm-agent',
      'm-organization',
      'm-waybill',
    ],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

i18n.on('languageChanged', applyLanguageToDocument);

registerLocalesHMR(i18n, import.meta.hot);

export default i18n;
